// extracted by mini-css-extract-plugin
export default {"dough":"Dough_dough__NrgL9","active":"Dough_active__I26BH"};